
export class OrderDetail {
  constructor(
    public productName: string,
    public productCategory: string,
    public discount: number,
    public quantity: number,
    public value: number
  ) { }

}